import { useNavigate } from 'react-router-dom'
import LighthouseLogo from 'assets/LighthouseLogo.svg?react'

import './style.scss'

export interface IDefaultFallbackProps {
  logoHeight?: number
  logoWidth?: number
  heading?: React.ReactNode
  paragraph?: React.ReactNode
}

export const DefaultFallback = ({
  logoHeight = 139,
  logoWidth = 162,
  heading = 'Sorry, something went wrong',
  paragraph
}: IDefaultFallbackProps) => {
  const navigate = useNavigate()

  const bodyText = paragraph || (
    <>
      Please{' '}
      <span
        tabIndex={0}
        onClick={() => navigate(-1)}
        className='cursor-pointer font-semibold text-blue-lighthouse-500'
      >
        go back
      </span>{' '}
      to the previous page to resume your work.
    </>
  )

  return (
    <main className='grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8'>
      <div className='text-center'>
        <LighthouseLogo
          role='img'
          style={{
            width: logoWidth,
            height: logoHeight,
            opacity: 0.5
          }}
          className='default-eb-fallback-logo mb-14 ml-auto mr-auto'
        />
        <h1 className='mt-4 text-4xl font-bold tracking-tight text-gray-700'>
          {heading}
        </h1>
        <p className='mt-6 text-2xl leading-7 text-gray-700'>{bodyText}</p>
        <div className='mt-14 flex items-center justify-center'>
          <button
            type='button'
            onClick={() => navigate('/risk-management/')}
            className='bg-blue-lighthouse-500 px-3.5 py-2.5 text-2xl font-semibold text-white'
          >
            Go To Homepage
          </button>
        </div>
      </div>
    </main>
  )
}

export default DefaultFallback
